import { connect } from 'react-redux'
import { useCallback, useEffect, useRef, useState } from 'react';
import './../styles/Authentication.css'
import Webcam from 'react-webcam';
import { bindActionCreators } from 'redux';
import { ACTION_AUTHENTICATION_COLLABORATOR, ACTION_AUTHENTICATION_VEHICLE, callAuthenticationOperationPost, callAuthenticationCollaboratorGet, callAuthenticationVehicleClear, callAuthenticationCollaboratorClear, callAuthenticationVehicleGet, callAuthenticationCollaboratorValidatePost } from '../actions/authentication';
import { toast } from 'react-toastify';

const videoConstraints = {
    width: 400,
    height: 400,
    facingMode: 'user'
}

let AuthenticationPage = ({ collaborator, vehicle, methods: { callAuthenticationCollaboratorGet, callAuthenticationVehicleGet, callAuthenticationCollaboratorClear, callAuthenticationCollaboratorValidatePost, callAuthenticationVehicleClear } }) => {
    const [loader, setLoader] = useState(true)
    const [terminalOpacity, setTerminalOpacity] = useState('0')
    const [terminalMarginTop, setTerminalMarginTop] = useState('100px')
    const [step, setStep] = useState(1)

    const [mainData, setMainData] = useState(ACTION_AUTHENTICATION_COLLABORATOR.payload)
    const [mainDocument, setMainDocument] = useState('')
    const mainWebcam = useRef()
    const [mainPhoto, setMainPhoto] = useState('')

    const [driverData, setDriverData] = useState(ACTION_AUTHENTICATION_COLLABORATOR.payload)
    const [driverDocument, setDriverDocument] = useState('')
    const driverWebcam = useRef()
    const [driverPhoto, setDriverPhoto] = useState('')

    const [vehicleData, setVehicleData] = useState(ACTION_AUTHENTICATION_VEHICLE.payload)
    const [vehicleCode, setVehicleCode] = useState('')

    const assistentWebcam = useRef()
    const [assistents, setAssistents] = useState([])
    const [assistentData, setAssistentData] = useState(ACTION_AUTHENTICATION_COLLABORATOR.payload)
    const [assistentDocument, setAssistentDocument] = useState('')
    const [assistentPhoto, setAssistentPhoto] = useState('')

    const resetData = () => {
        setMainDocument('')
        setMainPhoto('')
        setMainData(ACTION_AUTHENTICATION_COLLABORATOR.payload)

        setDriverDocument('')
        setDriverPhoto('')
        setDriverData(ACTION_AUTHENTICATION_COLLABORATOR.payload)

        setVehicleCode('')
        setVehicleData(ACTION_AUTHENTICATION_VEHICLE.payload)
        setAssistents([])
    }

    const captureMainPhoto = useCallback(() => {
        const pictureSrc = mainWebcam.current.getScreenshot()
        setMainPhoto(pictureSrc)
        callAuthenticationCollaboratorValidatePost(mainDocument, pictureSrc, () => {
            setStep(3)
        }, () => {
            setMainPhoto('')
        })
    }, [mainWebcam, setMainPhoto, mainDocument, callAuthenticationCollaboratorValidatePost, setStep])

    const captureDriverPhoto = useCallback(() => {
        const pictureSrc = driverWebcam.current.getScreenshot()
        setDriverPhoto(pictureSrc)
        callAuthenticationCollaboratorValidatePost(driverDocument, pictureSrc, () => {
            setStep(7)
        }, () => {
            setDriverPhoto('')
        })
    }, [driverWebcam, setDriverPhoto, driverDocument, callAuthenticationCollaboratorValidatePost, setStep])

    const captureAssistentPhoto = useCallback(() => {
        const pictureSrc = assistentWebcam.current.getScreenshot()
        setAssistentPhoto(pictureSrc)
        callAuthenticationCollaboratorValidatePost(assistentDocument, pictureSrc, () => {
            setStep(7)
            assistents.push(assistentData)
            setAssistents(assistents)
            setAssistentData(ACTION_AUTHENTICATION_COLLABORATOR.payload)
            setAssistentDocument('')
            setAssistentPhoto('')
        }, () => {
            setAssistentPhoto('')
        })
    }, [assistentWebcam, setAssistentPhoto, assistentDocument, callAuthenticationCollaboratorValidatePost, setStep, assistents, assistentData])

    const refVideo = useRef()

    const stopVideo = useCallback(() => {
        if (refVideo.current) {
            refVideo.current.currentTime = 0
            refVideo.current.pause()
            setLoader(false);
            setTimeout(() => {
                setTerminalOpacity('1')
                setTerminalMarginTop('0')
            }, 500)
        }
    }, [refVideo, setLoader, setTerminalOpacity, setTerminalMarginTop])

    const playVideo = useCallback(() => {
        if (refVideo.current) {
            refVideo.current.play()
        }
    }, [refVideo])

    useEffect(() => {
        document.title = 'Totem'
        playVideo()
    }, [playVideo])

    const submitMainDocument = () => {
        callAuthenticationCollaboratorGet(mainDocument)
    }

    const submitVehicleCode = () => {
        callAuthenticationVehicleGet(mainDocument, vehicleCode)
    }

    const submitDriverDocument = () => {
        callAuthenticationCollaboratorGet(driverDocument)
    }

    const next = useCallback(() => {
        setStep(step + 1)
    }, [step, setStep])

    useEffect(() => {
        if (collaborator.document !== '') {
            if (step === 1) {
                setMainData(collaborator)
                callAuthenticationCollaboratorClear()
            }
            if (step === 5) {
                setDriverData(collaborator)
                callAuthenticationCollaboratorClear()
            }
            if (step === 7) {
                setAssistentData(collaborator)
                callAuthenticationCollaboratorClear()
            }
            next()
        }
    }, [collaborator, next, callAuthenticationCollaboratorClear, step, setAssistentData, setMainData, setDriverData])

    useEffect(() => {
        if (vehicle.code !== '') {
            setVehicleData(vehicle)
            callAuthenticationVehicleClear()
            setStep(4)
        }
    }, [vehicle, callAuthenticationVehicleClear, setVehicleData, setStep])

    const startOperation = () => {
        callAuthenticationOperationPost({}, () => {
            begin()
        })
    }

    const begin = () => {
        setStep(1)
        setLoader(true)
        playVideo()
        resetData()
    }

    const submitAssistent = () => {
        if (mainDocument === assistentDocument) {
            setAssistentDocument('')
            toast.error('RE ' + assistentDocument + ' informado é do encarregado, informe outro!')
            return
        }
        if (driverDocument === assistentDocument) {
            setAssistentDocument('')
            toast.error('RE ' + assistentDocument + ' informado é do encarregado, informe outro!')
            return
        }

        for (let i = 0; i < assistents.length; i++) {
            if (assistents[i].document === assistentDocument) {
                setAssistentDocument('')
                toast.error('RE ' + assistentDocument + ' já foi adicionado com auxiliar!')
                return
            }
        }

        callAuthenticationCollaboratorGet(assistentDocument)
    }

    return (
        <div className='wrapper-totem d-flex flex-column align-items-center justify-content-center'>
            <video ref={refVideo} loop muted className="bg-video" style={{ display: loader ? 'block' : 'none' }} onClick={() => stopVideo()}>
                <source src="/assets/video/totem.mp4" type="video/mp4" />
            </video>
            {!loader ? (
                <>
                    <div className='d-flex justify-content-center align-items-center terminal' style={{ opacity: terminalOpacity, marginTop: terminalMarginTop }}>
                        <div className='logo-police d-flex justify-content-center'>
                            <img src='/assets/img/logo-police.png' alt='Telemetria' />
                        </div>
                        {step === 1 ? (
                            <div style={{ width: '300px' }}>
                                <h1 className='text-center text-white'>INFORME O ENCARREGADO</h1>
                                <div className='mt-4'>
                                    <input type='number' className='form-control form-control-lg bg-secondary text-center text-white' value={mainDocument} onChange={(e) => setMainDocument(e.target.value)} />
                                </div>
                                <div className='mt-4'>
                                    <span className='btn btn-secondary btn-lg btn-block' onClick={() => submitMainDocument()}>CONTINUAR</span>
                                </div>
                                <div className='mt-4'>
                                    <span className='btn btn-danger btn-lg btn-block' onClick={() => begin()}>REINICIAR</span>
                                </div>
                            </div>
                        ) : <></>}

                        {step === 2 ? (
                            <div style={{ width: '300px' }}>
                                <h1 className='text-center text-white'>AUTORIZANDO O ENCARREGADO</h1>
                                <div className='card'>
                                    <div className='card-body'>
                                        <strong>RE:</strong> {mainData.document}<br />
                                        <strong>Nome:</strong> {mainData.name}<br />
                                        <strong>Batalhão/Unidade:</strong> {mainData.companyUnit}<br />
                                        <strong>Função:</strong> {mainData.role}<br />
                                    </div>
                                </div>
                                {mainPhoto === '' ? (
                                    <>
                                        <div className='mt-4'>
                                            <Webcam
                                                ref={mainWebcam}
                                                audio={false}
                                                screenshotFormat="image/jpeg"
                                                videoConstraints={videoConstraints}
                                                style={{ width: '100%', height: 'auto', display: 'block' }}
                                            />
                                        </div>
                                        <div className='mt-4'>
                                            <span className='btn btn-secondary btn-lg btn-block' onClick={() => captureMainPhoto()}>VALIDAR</span>
                                        </div>
                                        <div className='mt-4'>
                                            <span className='btn btn-danger btn-lg btn-block' onClick={() => begin()}>REINICIAR</span>
                                        </div>
                                    </>
                                ) : <></>}
                            </div>
                        ) : <></>}

                        {step === 3 ? (
                            <div style={{ width: '300px' }}>
                                <h1 className='text-center text-white'>NÚMERO DA VIATURA</h1>
                                <div className='mt-4'>
                                    <input type='number' className='form-control form-control-lg bg-secondary text-center text-white' value={vehicleCode} onChange={(e) => setVehicleCode(e.target.value)} />
                                </div>
                                <div className='mt-4'>
                                    <span className='btn btn-secondary btn-lg btn-block' onClick={() => submitVehicleCode()}>CONTINUAR</span>
                                </div>
                                <div className='mt-4'>
                                    <span className='btn btn-danger btn-lg btn-block' onClick={() => begin()}>REINICIAR</span>
                                </div>
                            </div>
                        ) : <></>}

                        {step === 4 ? (
                            <div style={{ width: '300px' }}>
                                <h1 className='text-center text-white'>INFORMAÇÕES DA VIATURA</h1>
                                <div className='card mt-4'>
                                    <div className='card-body'>
                                        <strong>Número:</strong> {vehicleData.code}<br />
                                        <strong>Placa:</strong> {vehicleData.identity}<br />
                                        <strong>Batalhão/Unidade:</strong> {vehicleData.companyUnit}<br />
                                    </div>
                                </div>
                                <div className='mt-4'>
                                    <span className='btn btn-secondary btn-lg btn-block' onClick={() => setStep(5)}>CONTINUAR</span>
                                </div>
                                <div className='mt-4'>
                                    <span className='btn btn-danger btn-lg btn-block' onClick={() => begin()}>REINICIAR</span>
                                </div>
                            </div>
                        ) : <></>}

                        {step === 5 ? (
                            <div style={{ width: '300px' }}>
                                <h1 className='text-center text-white'>INFORME O MOTORISTA</h1>
                                <div className='mt-4'>
                                    <input type='number' className='form-control form-control-lg bg-secondary text-center text-white' value={driverDocument} onChange={(e) => setDriverDocument(e.target.value)} />
                                </div>
                                <div className='mt-4'>
                                    <span className='btn btn-secondary btn-lg btn-block' onClick={() => submitDriverDocument()}>CONTINUAR</span>
                                </div>
                                <div className='mt-4'>
                                    <span className='btn btn-danger btn-lg btn-block' onClick={() => begin()}>REINICIAR</span>
                                </div>
                            </div>
                        ) : <></>}

                        {step === 6 ? (
                            <div style={{ width: '300px' }}>
                                <h1 className='text-center text-white'>AUTORIZANDO O MOTORISTA</h1>
                                <div className='card'>
                                    <div className='card-body'>
                                        <strong>RE:</strong> {driverData.document}<br />
                                        <strong>Nome:</strong> {driverData.name}<br />
                                        <strong>Batalhão/Unidade:</strong> {driverData.companyUnit}<br />
                                        <strong>Função:</strong> {driverData.role}<br />
                                    </div>
                                </div>
                                {driverPhoto === '' ? (
                                    <>
                                        <div className='mt-4'>
                                            <Webcam
                                                ref={driverWebcam}
                                                audio={false}
                                                screenshotFormat="image/jpeg"
                                                videoConstraints={videoConstraints}
                                                style={{ width: '100%', height: 'auto', display: 'block' }}
                                            />
                                        </div>
                                        <div className='mt-4'>
                                            <span className='btn btn-secondary btn-lg btn-block' onClick={() => captureDriverPhoto()}>VALIDAR</span>
                                        </div>
                                        <div className='mt-4'>
                                            <span className='btn btn-danger btn-lg btn-block' onClick={() => begin()}>REINICIAR</span>
                                        </div>
                                    </>
                                ) : <></>}
                            </div>
                        ) : <></>}

                        {step === 7 ? (
                            <div style={{ width: '300px' }}>
                                <h1 className='text-center text-white'>INFORME UM AUXILIAR</h1>
                                {assistents.map((a, ai) => (
                                    <div className='card mt-4'>
                                        <div className='card-body'>
                                            <strong>RE:</strong> {a.document}<br />
                                            <strong>Nome:</strong> {a.name}<br />
                                            <strong>Batalhão/Unidade:</strong> {a.companyUnit}<br />
                                            <strong>Função:</strong> {a.role}<br />
                                        </div>
                                    </div>
                                ))}
                                <div className='mt-4'>
                                    <input type='number' className='form-control form-control-lg bg-secondary text-center text-white' value={assistentDocument} onChange={(e) => setAssistentDocument(e.target.value)} />
                                </div>
                                <div className='mt-4'>
                                    <span className='btn btn-secondary btn-lg btn-block' onClick={() => submitAssistent()}>ADICIONAR</span>
                                </div>
                                <div className='mt-4'>
                                    <span className='btn btn-success btn-lg btn-block' onClick={() => startOperation()}>INICIAR OPERAÇÃO</span>
                                </div>
                                <div className='mt-4'>
                                    <span className='btn btn-danger btn-lg btn-block' onClick={() => begin()}>REINICIAR</span>
                                </div>
                            </div>
                        ) : <></>}

                        {step === 8 ? (
                            <div style={{ width: '300px' }}>
                                <h1 className='text-center text-white'>AUTORIZANDO O AUXILIAR</h1>
                                <div className='card'>
                                    <div className='card-body'>
                                        <strong>RE:</strong> {assistentData.document}<br />
                                        <strong>Nome:</strong> {assistentData.name}<br />
                                        <strong>Batalhão/Unidade:</strong> {assistentData.companyUnit}<br />
                                        <strong>Função:</strong> {assistentData.role}<br />
                                    </div>
                                </div>
                                {assistentPhoto === '' ? (
                                    <>
                                        <div className='mt-4'>
                                            <Webcam
                                                ref={assistentWebcam}
                                                audio={false}
                                                screenshotFormat="image/jpeg"
                                                videoConstraints={videoConstraints}
                                                style={{ width: '100%', height: 'auto', display: 'block' }}
                                            />
                                        </div>
                                        <div className='mt-4'>
                                            <span className='btn btn-secondary btn-lg btn-block' onClick={() => captureAssistentPhoto()}>VALIDAR</span>
                                        </div>
                                        <div className='mt-4'>
                                            <span className='btn btn-danger btn-lg btn-block' onClick={() => begin()}>REINICIAR</span>
                                        </div>
                                    </>
                                ) : <></>}
                            </div>
                        ) : <></>}
                    </div>
                </>
            ) : <></>}

        </div>
    )
}

const mapStateToProps = ({ totem: { collaborator, vehicle } }) => ({
    collaborator: collaborator,
    vehicle: vehicle
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callAuthenticationCollaboratorGet,
            callAuthenticationCollaboratorClear,
            callAuthenticationVehicleGet,
            callAuthenticationCollaboratorValidatePost,
            callAuthenticationVehicleClear,
            callAuthenticationOperationPost
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationPage)